/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmploymentDetailsViewModel } from './EmploymentDetailsViewModel';
import {
    EmploymentDetailsViewModelFromJSON,
    EmploymentDetailsViewModelFromJSONTyped,
    EmploymentDetailsViewModelToJSON,
} from './EmploymentDetailsViewModel';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { TaxDetailsViewModel } from './TaxDetailsViewModel';
import {
    TaxDetailsViewModelFromJSON,
    TaxDetailsViewModelFromJSONTyped,
    TaxDetailsViewModelToJSON,
} from './TaxDetailsViewModel';
import type { WithholdingTaxViewModel } from './WithholdingTaxViewModel';
import {
    WithholdingTaxViewModelFromJSON,
    WithholdingTaxViewModelFromJSONTyped,
    WithholdingTaxViewModelToJSON,
} from './WithholdingTaxViewModel';

/**
 * 
 * @export
 * @interface EmploymentAndTaxDetailsViewModel
 */
export interface EmploymentAndTaxDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    isLivingAnnuity?: boolean;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    isUsCitizen?: IAPYESORNO;
    /**
     * 
     * @type {EmploymentDetailsViewModel}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    employmentDetails?: EmploymentDetailsViewModel;
    /**
     * 
     * @type {TaxDetailsViewModel}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    taxDetails?: TaxDetailsViewModel;
    /**
     * 
     * @type {WithholdingTaxViewModel}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    withholdingTaxes?: WithholdingTaxViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    isComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    isDiscretionarySavingsProducts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    isEndowmentOrSinkingFund?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmploymentAndTaxDetailsViewModel
     */
    canAskUsCitizenship?: boolean;
}

/**
 * Check if a given object implements the EmploymentAndTaxDetailsViewModel interface.
 */
export function instanceOfEmploymentAndTaxDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function EmploymentAndTaxDetailsViewModelFromJSON(json: any): EmploymentAndTaxDetailsViewModel {
    return EmploymentAndTaxDetailsViewModelFromJSONTyped(json, false);
}

export function EmploymentAndTaxDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmploymentAndTaxDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'isLivingAnnuity': !exists(json, 'IsLivingAnnuity') ? undefined : json['IsLivingAnnuity'],
        'isUsCitizen': !exists(json, 'IsUsCitizen') ? undefined : IAPYESORNOFromJSON(json['IsUsCitizen']),
        'employmentDetails': !exists(json, 'EmploymentDetails') ? undefined : EmploymentDetailsViewModelFromJSON(json['EmploymentDetails']),
        'taxDetails': !exists(json, 'TaxDetails') ? undefined : TaxDetailsViewModelFromJSON(json['TaxDetails']),
        'withholdingTaxes': !exists(json, 'WithholdingTaxes') ? undefined : WithholdingTaxViewModelFromJSON(json['WithholdingTaxes']),
        'isComplete': json['IsComplete'],
        'isDiscretionarySavingsProducts': !exists(json, 'IsDiscretionarySavingsProducts') ? undefined : json['IsDiscretionarySavingsProducts'],
        'isEndowmentOrSinkingFund': !exists(json, 'IsEndowmentOrSinkingFund') ? undefined : json['IsEndowmentOrSinkingFund'],
        'canAskUsCitizenship': !exists(json, 'CanAskUsCitizenship') ? undefined : json['CanAskUsCitizenship'],
    };
}

export function EmploymentAndTaxDetailsViewModelToJSON(value?: EmploymentAndTaxDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'IsLivingAnnuity': value.isLivingAnnuity,
        'IsUsCitizen': IAPYESORNOToJSON(value.isUsCitizen),
        'EmploymentDetails': EmploymentDetailsViewModelToJSON(value.employmentDetails),
        'TaxDetails': TaxDetailsViewModelToJSON(value.taxDetails),
        'WithholdingTaxes': WithholdingTaxViewModelToJSON(value.withholdingTaxes),
        'IsComplete': value.isComplete,
        'IsDiscretionarySavingsProducts': value.isDiscretionarySavingsProducts,
        'IsEndowmentOrSinkingFund': value.isEndowmentOrSinkingFund,
        'CanAskUsCitizenship': value.canAskUsCitizenship,
    };
}

